import type { ForNodeType } from "@/components/features/_model/types";

type Props = {
	description: ForNodeType<string>;
	onSetViewModel: (
		values: {
			key: "description";
			value: ForNodeType<string>;
		}[],
	) => void;
};

export const useOptionDescription = ({ description, onSetViewModel }: Props) => {
	const onSetDescription = (input: string) => {
		onSetViewModel([{ key: "description", value: { ...description, value: input } }]);
	};

	return {
		description,
		onSetDescription,
	};
};
